import { createContext, FC, ReactNode } from 'react';

export const NotificationContext = createContext<boolean>(false);

interface NotificationContextProviderProps {
  children?: ReactNode;
  isDisableSave: boolean;
}

export const NotificationContextProvider: FC<
  NotificationContextProviderProps
> = ({ children, isDisableSave }: NotificationContextProviderProps) => {
  return (
    <NotificationContext.Provider value={isDisableSave}>
      {children}
    </NotificationContext.Provider>
  );
};
